import axios from "axios";
import { useEffect, useState } from "react";

export default function Wishlist() {
  const [items, setItems] = useState([]);

  const user_id = localStorage.getItem("user_id");

  // ✅ LOAD WISHLIST
  const loadWishlist = () => {

  const location =
    localStorage.getItem("storeLocation");
console.log("LOCATION:", location);
  axios
    .get(
      `https://apple2.shopat1stop.com/api/wishlist/${user_id}/${location}`
    )
    .then(res => setItems(res.data))
    .catch(err => console.log(err));
};

  useEffect(() => {

  loadWishlist();

  const interval = setInterval(() => {
    loadWishlist();
  }, 1000);

  return () => clearInterval(interval);

}, []);

  // ❌ REMOVE
const removeItem = (wishlist_id) => {
  axios
    .delete(`https://apple2.shopat1stop.com/api/wishlist/${wishlist_id}`)
    .then(() => loadWishlist());
};

  // 🔥 MOVE TO CART
  // 🔥 MOVE TO CART
const moveToCart = async (item) => {

  try {

    // ADD TO CART
   await axios.post(
  "https://apple2.shopat1stop.com/api/cart",
  {
    user_id,
    product_id: item.product_id,
    store_name:
      localStorage.getItem("storeLocation")
  }
);

    // REMOVE FROM WISHLIST
    await axios.delete(
      `https://apple2.shopat1stop.com/api/wishlist/${item.wishlist_id}`
    );

    alert("Moved to cart ✅");

    // REFRESH
    loadWishlist();

  } catch (err) {

    console.log(err);

    alert("Move failed ❌");

  }

};

  return (
    <div style={{ padding: 20 }}>
      <h2>❤️ Your Wishlist</h2>

      {items.length === 0 && <h3>No items in wishlist ❌</h3>}

      {items.map(item => (
        <div key={item.wishlist_id} style={{
          border: "1px solid #ddd",
          margin: 10,
          padding: 10,
          display: "flex",
          gap: 20,
          alignItems: "center"
        }}>

         <img
  src={
    item.image
      ? `https://apple2.shopat1stop.com${item.image}`
      : "https://via.placeholder.com/100"
  }
  width="100"
  alt={item.name}
/>

          <div>
            <h4>{item.name}</h4>
            <p>${item.price}</p>

            {/* 🔥 MOVE TO CART */}
            <button
              style={{
                background: "green",
                color: "white",
                border: "none",
                padding: "5px 10px",
                marginRight: 10,
                cursor: "pointer"
              }}
              onClick={() => moveToCart(item)}
            >
              Move to Cart 🛒
            </button>

            {/* ❌ REMOVE */}
            <button
              style={{
                background: "red",
                color: "white",
                border: "none",
                padding: "5px 10px",
                cursor: "pointer"
              }}
              onClick={() => removeItem(item.wishlist_id)}
            >
              Remove ❌
            </button>

          </div>

        </div>
      ))}
    </div>
  );
}